import React from 'react';
import type { TimelineDuration, TimelineMode } from '../../../../model/timeline';
import { getTimelineWidth } from '../../common/utils/timeline.tsx';
import ChartItem, { type APIProps as ChartItemProps } from './view';

type APIProps = ChartItemProps & {
	timelineMode: TimelineMode;
	timelineDuration: TimelineDuration;
};

const WrappedChartItem = ({ timelineMode, timelineDuration, ...props }: APIProps) => {
	const timelineWidth = getTimelineWidth(timelineMode, timelineDuration);

	return <ChartItem {...props} timelineWidth={timelineWidth} />;
};

export default WrappedChartItem;
export type { APIProps };
